var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHexLogo = function SvgHexLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 52 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9 0v6.973H7V0H0v20h7V10h2v10h7V0zm9 20h16v-8h-7v5h-2v-7h9V0H18zm7-13V3h2v4zm20 0V0h7v5l-3 3.5 3 3.5v8h-7V9.973h-2V20h-7v-8l3-3.5L36 5V0h7v7z",
    clipRule: "evenodd"
  })));
};
export { SvgHexLogo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNTIgMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNOSAwVjYuOTczMzNIN1YwSDBWNS42NTMzM1Y1LjY3MzMzVjEyLjMyNjdWMjBIN1YxMEg5VjIwSDE2VjBIOVpNMTggMjBIMzRWMTJIMjdWMTdIMjVWMTBIMzRWMEgxOFYyMFpNMjUgN1YzSDI3VjdIMjVaTTQ1IDdWMEg1MlY1TDQ5IDguNUw1MiAxMlYyMEg0NVY5Ljk3MzMzSDQzVjIwSDM2VjEyTDM5IDguNUwzNiA1VjBINDNWN0g0NVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";